import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'
import { ApiError } from './api'
import { meQuery } from './queries'

/** Route guard: resolves to the signed-in user or redirects to sign in,
 *  remembering where the person was headed. */
export async function requireUser(queryClient: QueryClient, href: string) {
  try {
    return await queryClient.ensureQueryData(meQuery)
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) {
      throw redirect({ to: '/login', search: { next: href } })
    }
    throw e
  }
}

/** Only follow same-site paths, so ?next= can't bounce someone off-site. */
export function safeNext(next: unknown): string | undefined {
  return typeof next === 'string' && next.startsWith('/') && !next.startsWith('//') ? next : undefined
}
